import React from 'react';
import InputContainer from '../../../../../../obps/src/pages/citizen/TCPForms/layout/inputContainer';
import { useForm } from "react-hook-form";
import ButtonWrapper from '../../TCPForms/components/Button';

const FilterForm = () => {
    const { handleSubmit, control } = useForm();
    const { data: cities, isLoading } = Digit.Hooks.useTenants();
    const applicationFlow = Digit?.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW") || null;
    const districts = !isLoading && applicationFlow ? cities?.filter((city) => city.code?.includes(applicationFlow.toLowerCase())) : [];
    const onSubmit = (data) => {
        console.log(data)
    }
    return (
        <section className="container1">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="formContainer" style={{ marginTop: '-80px' }}>
                    <div className="formHeaderContainer">
                        <h2 className="formHeading">
                            Registered Private Professionals
                        </h2>
                    </div>
                    <div className="formInputContainer" style={{ width: '100%', justifyContent: 'space-around' }}>
                        <div className="columnWrapper">
                            <InputContainer
                                label="State"
                                control={control}
                                placeholder="Uttar Pradesh"
                                name="state"
                                type="textInput"
                                defaultValue={'Uttar Pradesh'}
                                disabled
                                width={"18.25vw"}
                            />
                            <InputContainer
                                label="Tehsil"
                                control={control}
                                placeholder="Tehsil"
                                name="tehsil"
                                type="textInput"
                                width={'18.25vw'}
                            />
                            <InputContainer
                                label="Class"
                                control={control}
                                placeholder="All--"
                                name="class"
                                type="selectInput"
                                data={[
                                    { label: 'All', value: 'All' },
                                    { label: 'A', value: 'A' },
                                    { label: 'B', value: 'B' },
                                    { label: 'C', value: 'C' }
                                ]}
                            />

                        </div>
                        <div className="columnWrapper">
                            <InputContainer
                                label="District"
                                control={control}
                                placeholder="Select District"
                                inputLabel="Select District"
                                name="district"
                                mandatory
                                type="selectInput"
                                data={districts}
                            />
                            <InputContainer
                                control={control}
                                label="Private Prof. Name"
                                placeholder="Enter Name"
                                name="architectName"
                                type="textInput"
                                width={'18.25vw'}
                            />
                            <InputContainer
                                label="Applied by"
                                control={control}
                                placeholder="All--"
                                data={[
                                    { value: 'Architect', label: 'Architect' },
                                    { value: 'Engineer', label: 'Engineer' },
                                    { value: 'Draughts Man', label: 'Draughts Man' },
                                    { value: 'Structutal Engineer', label: 'Structural Engineer' },
                                ]
                                }
                                name="appliedby"
                                type="selectInput"
                            />
                        </div>
                    </div>
                </div>
                <div className="footerContainer">
                    <div className="buttonWrapper">
                        <ButtonWrapper
                            variant="contained"
                            color="success"
                            size="medium"
                            label="Search"
                            type="submit"
                            onClick={handleSubmit}
                        />
                        <ButtonWrapper
                            variant="contained"
                            color="error"
                            size="medium"
                            label="Reset"
                        />
                    </div>
                </div>
            </form>
        </section>
    );
};

export default FilterForm;
